module.exports = __webpack_public_path__ + "components/outside-promo-page/static/skiers-08f1a4351d0c499a876d6cf3a4aeb21b.webp";